import _asyncToGenerator from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import AppLayout from '../components/AppLayout';
var Index = /*#__PURE__*/function (_Component) {
  _inherits(Index, _Component);
  var _super = _createSuper(Index);
  function Index() {
    _classCallCheck(this, Index);
    return _super.apply(this, arguments);
  }
  _createClass(Index, [{
    key: "render",
    value: function render() {
      return __jsx(AppLayout, {
        title: "Dashboard"
      }, __jsx(React.Fragment, null));
    }
  }], [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tables, i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tables = [];
                for (i = 0; i < 46; i++) {
                  tables.push({
                    key: i,
                    name: "Edward King ".concat(i),
                    age: 32 + i,
                    address: "London, Park Lane no. ".concat(i),
                    tags: ['nice', 'developer', "number".concat(i)]
                  });
                }
                return _context.abrupt("return", {
                  data: tables
                });
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function getInitialProps() {
        return _getInitialProps.apply(this, arguments);
      }
      return getInitialProps;
    }()
  }]);
  return Index;
}(Component);
export default Index;